import { Action, createReducer, on } from '@ngrx/store'
import { FolderOverviewActions, FolderScopesActions } from '../actions'

import { FolderOverviewState } from '../models'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { folderOverviewInitialState } from '../const'
import { plainToInstance } from 'class-transformer'

const getCurrentFolderHandler = (state: FolderOverviewState) => ({
  ...state,
  folder: undefined,
  folderScopes: [],
  isLoading: true,
})

const getCurrentFolderSuccessHandler = (state: FolderOverviewState, { folder }) => ({
  ...state,
  folder: plainToInstance(FolderVersion, folder),
  isLoading: false,
})

const getCurrentFolderFailHandler = (state: FolderOverviewState, error) => ({ ...state, error, isLoading: false })

const updateFolderSuccessHandler = (state: FolderOverviewState, { folder }) => ({
  ...state,
  isLoading: false,
  folder: plainToInstance(FolderVersion, folder),
})

const getRetainedHoursStatsSuccessHandler = (state: FolderOverviewState, { retainedHoursStats }) => ({
  ...state,
  retainedHoursStats,
})

const deleteScopeSuccessHandler = (state: FolderOverviewState, { id }) => ({
  ...state,
  folderScopes: state.folderScopes.filter((scope) => scope.identity.id !== id),
})

const updateScopeSuccessHandler = (state: FolderOverviewState, { scope }) => ({
  ...state,
  folderScopes: plainToInstance(
    ScopeVersion,
    state.folderScopes.map((s) => (s.id == scope.id ? scope : s))
  ),
})

const updateDeliverableSuccessHandler = (state: FolderOverviewState, { scope, deliverable }) => {
  const updatedScope = plainToInstance(ScopeVersion, {
    ...scope,
    deliverables: scope.deliverables.map((d) => (d.id == deliverable.id ? deliverable : d)),
  })
  return updateScopeSuccessHandler(state, { scope: updatedScope })
}

const updateComponentSuccessHandler = (state: FolderOverviewState, { scope, component }) => {
  const deliverable = scope.deliverables.find((d) => (d.id == deliverable.id ? deliverable : d))
  return updateDeliverableSuccessHandler(state, {
    scope,
    deliverable: {
      ...deliverable,
      components: deliverable.components.map((c) => (c.id == component.id ? component : c)),
    },
  })
}

const getFolderScopesSuccessHandler = (state: FolderOverviewState, { scopes }) => ({
  ...state,
  folderScopes: scopes,
})

const trafficScopesHandler = (state: FolderOverviewState) => ({ ...state, trafficStatus: null })

const trafficScopesSuccessHandler = (state: FolderOverviewState, { trafficStatus }) => ({ ...state, trafficStatus })

const FolderOverviewReducer = createReducer(
  folderOverviewInitialState,
  on(FolderOverviewActions.getCurrentFolder, FolderOverviewActions.changeFolderVersion, getCurrentFolderHandler),
  on(
    FolderOverviewActions.getCurrentFolderSuccess,
    FolderOverviewActions.changeFolderVersionSuccess,
    getCurrentFolderSuccessHandler
  ),
  on(
    FolderOverviewActions.getCurrentFolderFail,
    FolderOverviewActions.changeFolderVersionFail,
    getCurrentFolderFailHandler
  ),
  on(FolderOverviewActions.getFolderScopesSuccess, getFolderScopesSuccessHandler),
  on(FolderOverviewActions.updateFolderSuccess, updateFolderSuccessHandler),
  on(FolderOverviewActions.getRetainedHoursStatsSuccess, getRetainedHoursStatsSuccessHandler),
  on(FolderScopesActions.deleteScopeSuccess, FolderScopesActions.removeScopeSuccess, deleteScopeSuccessHandler),
  on(FolderScopesActions.updateScopeSuccess, updateScopeSuccessHandler),
  on(FolderScopesActions.updateDeliverableSuccess, updateDeliverableSuccessHandler),
  on(FolderScopesActions.updateComponentSuccess, updateComponentSuccessHandler),
  on(FolderOverviewActions.trafficScopes, trafficScopesHandler),
  on(FolderOverviewActions.trafficScopesSuccess, trafficScopesSuccessHandler)
)

export function folderOverviewReducer(state: FolderOverviewState | undefined, action: Action): FolderOverviewState {
  return FolderOverviewReducer(state, action)
}
